/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCreateRemarksTemplateRequest
 */
export interface RequestCreateRemarksTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestCreateRemarksTemplateRequest
     */
    baseId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateRemarksTemplateRequest
     */
    template: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateRemarksTemplateRequest
     */
    tenantId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateRemarksTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateRemarksTemplateRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestCreateRemarksTemplateRequest interface.
 */
export function instanceOfRequestCreateRemarksTemplateRequest(value: object): value is RequestCreateRemarksTemplateRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('template' in value) || value['template'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestCreateRemarksTemplateRequestFromJSON(json: any): RequestCreateRemarksTemplateRequest {
    return RequestCreateRemarksTemplateRequestFromJSONTyped(json, false);
}

export function RequestCreateRemarksTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateRemarksTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'template': json['template'],
        'tenantId': json['tenant_id'],
        'title': json['title'],
        'userId': json['user_id'],
    };
}

export function RequestCreateRemarksTemplateRequestToJSON(json: any): RequestCreateRemarksTemplateRequest {
    return RequestCreateRemarksTemplateRequestToJSONTyped(json, false);
}

export function RequestCreateRemarksTemplateRequestToJSONTyped(value?: RequestCreateRemarksTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'template': value['template'],
        'tenant_id': value['tenantId'],
        'title': value['title'],
        'user_id': value['userId'],
    };
}

